import axios from "../../../axios";

export function fetchProfileData() {
  const response = axios.get(`/accounts/profile/`);
  return response;
}
export function updateProfileData(payload: any) {
  const response = axios.put(`/accounts/profile/`, payload);
  return response;
}
export function emailVerification(email: string) {
  const response = axios.post(`/accounts/send-verification-email/`, { email });
  return response;
}
export function fetchReferralCode() {
  const response = axios.get(`/accounts/referral/code/`);
  return response;
}
